import React from "react";
import CourseCard from "components/CourseBuilder/CourseCard/CourseCard";
import { useTeamContext } from "store/contexts/teamContext";
import { useUserContext } from "store/contexts/userContext";
import { useSelector } from "react-redux";
import Loader from "components/Loader";

export default ({ courses, total }) => {
  const { team } = useTeamContext();
  const { user } = useUserContext();
  const { isLoading } = useSelector((state) => state.courseReducer);
  
  // Filter courses based on criteria
  const filteredCourses = courses.filter(course => {
    // Check if the course was created by the current user
    const isCreatedByCurrUser = course.creator && 
      (Number(course.creator.id) === Number(user?.id));
    
    // Check if the course was created in this team
    const isCreatedInCurrentTeam = Number(course.team_id) === Number(team?.id);
    
    // Only show courses that were:
    // 1. Created by the current user in the current team
    // 2. AND were created in this team (not just assigned to it)
    return isCreatedByCurrUser && isCreatedInCurrentTeam;
  });
  
  const noCourses = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "100px 0",
    fontSize: "22px",
    fontWeight: "500",
  };

  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: "100px 0",
  };

  return (
    <div className="courses-cards">
      <div className="row courseRow">
        {filteredCourses.map((course, index) => {
          // Determine if this is an assigned course that was created by another user
          const isAssignedCourse = course.creator && 
            Number(course.creator.id) !== Number(user?.id) &&
            course.assigned_teams && 
            course.assigned_teams.some(assignedTeam => 
              Number(assignedTeam.id) === Number(team?.id));
            
          return (
            <CourseCard 
              key={course.id} 
              course={course} 
              index={index} 
              teamId={team?.id}
              isAssignedCourse={isAssignedCourse}
            />
          );
        })}
      </div>
      {isLoading && <div style={loaderStyle}><Loader /></div>}
      {!isLoading && (filteredCourses.length === 0 || total === 0) && <div style={noCourses}>No courses created in this team</div>}
    </div>
  );
}; 